// Kept dependency-free so router.tsx can import these without pulling the
// branding editor tree (brandingConfig.tsx) into the main bundle.
export const MESSAGE_TYPES = {
    sendTicket: 'sendTicket',
    orderConfirmation: 'orderConfirmation',
    arrivalConfirmation: 'arrivalConfirmation',
    desperate: 'desperate',
    billing: 'billing'
} as const;

export const DELIVERY_TYPES = {
    email: 'email',
    sms: 'sms',
    whatsapp: 'whatsapp'
} as const;
